export const SET_ADD_TO_CART_FEEDBACK_ITEMS = 'checkout/SET_ADD_TO_CART_FEEDBACK_ITEMS';
export const SET_ADD_TO_CART_FEEDBACK_VOUCHER = 'checkout/SET_ADD_TO_CART_FEEDBACK_VOUCHER';
export const SET_ADD_TO_CART_FEEDBACK_COMBINED_WITH_ITEMS = 'checkout/SET_ADD_TO_CART_FEEDBACK_COMBINED_WITH_ITEMS';
export const SET_IS_ADD_TO_CART_FEEDBACK_VISIBLE = 'checkout/SET_IS_ADD_TO_CART_FEEDBACK_VISIBLE';
export const SET_ADD_TO_CART_FEEDBACK_CURRENCY = 'checkout/SET_ADD_TO_CART_FEEDBACK_CURRENCY';
export const SET_CURRENT_UPSELL_ITEM = 'checkout/SET_CURRENT_UPSELL_ITEM';
export const SET_IS_UPSELL_ITEM_SIZES_VISIBLE = 'checkout/SET_IS_UPSELL_ITEM_SIZES_VISIBLE';
export const SET_WIDGET_ID = 'checkout/SET_WIDGET_ID';
